module.exports = __webpack_public_path__ + "ef9c10b9378684f3eaaf24ae20b228fd.png";